import Vue from 'vue'
import Vuex from 'vuex'

import * as accessAuthority from './modules/accessAuthority'
import * as accessToken from './modules/accessToken'
import * as activityLog from './modules/activityLog'
import * as admin from './modules/admin'
import * as announcement from './modules/announcement'
import * as area from './modules/area'
import * as authentication from './modules/authentication'
import * as card from './modules/card'
import * as company from './modules/company'
import * as companyLeaveRight from './modules/companyLeaveRight'
import * as companyLocation from './modules/companyLocation'
import * as download from './modules/download'
import * as duty from './modules/duty'
import * as employee from './modules/employee'
import * as employeeLeaveRight from './modules/employeeLeaveRight'
import * as employeeLevel from './modules/employeeLevel'
import * as employeePolicy from './modules/employeePolicy'
import * as employeesGroup from './modules/employeesGroup'
import * as employeeType from './modules/employeeType'
import * as feature from './modules/feature'
import * as firmware from './modules/firmware'
import * as gender from './modules/gender'
import * as googleMap from './modules/googleMap'
import * as hardware from './modules/hardware'
import * as hardware3rdParty from './modules/hardware3rdParty'
import * as hardwaresGroup from './modules/hardwaresGroup'
import * as holiday from './modules/holiday'
import * as leave from './modules/leave'
import * as leaveApproval from './modules/leaveApproval'
import * as leaveApprover from './modules/leaveApprover'
import * as leaveFile from './modules/leaveFile'
import * as leaveType from './modules/leaveType'
import * as locationType from './modules/locationType'
import * as lockUnlock from './modules/lockUnlock'
import * as microsoftEntraId from './modules/microsoftEntraId'
import * as offsiteLocation from './modules/offsiteLocation'
import * as organization from './modules/organization'
import * as password from './modules/password'
import * as position from './modules/position'
import * as prefix from './modules/prefix'
import * as report from './modules/report'
import * as rightsGroup from './modules/rightsGroup'
import * as role from './modules/role'
import * as shift from './modules/shift'
import * as taEmployeesGroup from './modules/taEmployeesGroup'
import * as taHardwaresGroup from './modules/taHardwaresGroup'
import * as taRightsGroup from './modules/taRightsGroup'
// TODO: Remove timeAttendanceOffSiteGrant and rename timeAttendanceOffsiteGrants to timeAttendanceOffsiteGrant
import * as timeAttendanceOffSiteGrant from './modules/timeAttendanceOffSiteGrant'
import * as timeAttendanceOffsiteGrants from './modules/timeAttendanceOffsiteGrants'
import * as timezone from './modules/timezone'
import * as transaction from './modules/transaction'
import * as upload from './modules/upload'
import * as userRole from './modules/userRole'
import * as webhook from './modules/webhook'
import * as wfhLocation from './modules/wfhLocation'
import * as workingHours from './modules/workingHours'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: true,
    breadcrumbs: [],
    snackbar: {
      show: false,
      color: 'info',
      timeout: 2000,
      message: 'Message For User',
    },
    loading: false,
    uiCtrl: null,
  },
  mutations: {
    SET_DRAWER(state, drawer) {
      state.drawer = drawer
    },
    SET_BREADCRUMBS(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar
    },
    SET_UI_CTRL(state, uiCtrl) {
      state.uiCtrl = uiCtrl
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {},
  modules: {
    authentication,
    position,
    employeeType,
    shift,
    organization,
    employee,
    admin,
    role,
    company,
    accessToken,
    download,
    upload,
    prefix,
    gender,
    timeAttendanceOffSiteGrant,
    googleMap,
    duty,
    hardware,
    hardware3rdParty,
    card,
    feature,
    holiday,
    taRightsGroup,
    taHardwaresGroup,
    taEmployeesGroup,
    rightsGroup,
    hardwaresGroup,
    employeesGroup,
    timezone,
    area,
    employeeLevel,
    report,
    lockUnlock,
    userRole,
    employeePolicy,
    activityLog,
    firmware,
    leaveType,
    leaveApprover,
    leaveApproval,
    leaveFile,
    password,
    announcement,
    accessAuthority,
    webhook,
    microsoftEntraId,
    transaction,
    companyLeaveRight,
    employeeLeaveRight,
    leave,
    workingHours,
    locationType,
    companyLocation,
    offsiteLocation,
    wfhLocation,
    timeAttendanceOffsiteGrants,
  },
})
